'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require('../../company/publications/order/CompanyPublicationOrderService.js');

function CompanyGuestPublicationGroupDetailCtrl(
  $scope,
  publication,
  files,
  children,
  order,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.files = files;
  $scope.translations = translations;
  $scope.children = children;
  $scope.order = order;
  $scope.activityService = activityService;

  $scope.setDefaultColor = function() {
    $scope.children.forEach(function(c,i){
      if (!c.category) {
        $scope.children[i].category = {};
        $scope.children[i].category.color = 4279856278; // #196c96
      }
    });
  };

  $scope.setDefaultColor();

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/publication-group/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestPublicationGroupDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  order: ['CompanyCustomersService', '$stateParams', 'publication' , function(CompanyCustomersService, $stateParams, publication){
    if (publication.features.currentCustomerId) {
        return CompanyCustomersService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        customerId: publication.features.currentCustomerId
      }).$promise;
    }
    return false;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestPublicationGroupDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationGroupDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'children',
  'order',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestPublicationGroupDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/publication-group/CompanyGuestPublicationGroupDetailCtrl.js
// module id = 298
// module chunks = 0